import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=48360f5f&scoped=true&"
import script from "./AccountView.vue?vue&type=script&lang=js&"
export * from "./AccountView.vue?vue&type=script&lang=js&"
import style0 from "./AccountView.vue?vue&type=style&index=0&id=48360f5f&lang=scss&scoped=true&"
import style1 from "./AccountView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48360f5f",
  null
  
)

export default component.exports